import { render, staticRenderFns } from "./PreviewClassicAttribute.vue?vue&type=template&id=2464024e&scoped=true"
import script from "./PreviewClassicAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewClassicAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464024e",
  null
  
)

export default component.exports